// components/Footer.js
export default function Footer(){
  return (
    <footer style={{textAlign:"center", padding:"30px", background:"#111", marginTop:"60px"}}>
      © {new Date().getFullYear()} AF Dienstleistungen – Alle Rechte vorbehalten
    </footer>
  );
}
